import {Component,  OnDestroy, NgZone} from '@angular/core'
import {Injectable,EventEmitter, Output} from '@angular/core'
// import { Http, Headers} from '@angular/http' 
import {HttpClient, HttpHeaders} from '@angular/common/http'
import {Router} from '@angular/router'
import {Observable} from 'rxjs'
import { appStateProvider } from '../insa-providers/AppStateProvider'
import { InsaService } from '../insa-services/insa.service'
import { PerformancePivotListModel } from '../insa-models/performancePivot.model'
import { MultiSelectCustomModule } from '../insa-custom-scripts/multiselect-filter'
import { appConfig } from '../../insaweb.config';
//
import './style/pivotviewer.css'
import './lib/leaflet/leaflet.css'


// wicket is not used!
// import './html5pivot/lib/wicket/wicket.min.js';

import './lib/jquery-ui/jquery-ui-1.10.4.custom.min.js';

import './lib/easing/easing.js';
import './lib/jquery.mousewheel/jquery.mousewheel.min.js';
import './lib/jquery.tooltipster/jquery.tooltipster.min.js';
import './lib/colResizable/colResizable-1.3.min.js';
import './lib/purl-master/purl.js';
import './lib/leaflet/leaflet-0.6.4.js';

import { loadPivotCollectionFactory } from './pivot_loader';


@Component({
    selector: 'insaweb-pivot',
    template: '<div id="pivotviewer" (window:resize)="onResize($event)"></div>'
})
export class DashboardComponent implements OnDestroy{
    private sessionID: string ="";
    private performanceID: number;
    private pivotCollectionSubscription;
    private performanceGridData: any;
    ActiveStateIsChecked: boolean = (appConfig.ActiveIsChecked!==undefined) ? appConfig.ActiveIsChecked : false;

    constructor(private http: HttpClient, private _router: Router,private _appStateProvider:appStateProvider,private zone: NgZone, private _insaService: InsaService){
        window['dashboardComponentRef'] = {
        zone: this.zone, 
        component: this
      };
      this.pivotCollectionSubscription = this._insaService.PerformancePivotListEvent.subscribe(newPivotCollection => this.refreshPivotCollection(newPivotCollection));
    }

   private refreshPivotCollection(newPivotCollection){
      if(newPivotCollection!==undefined){
          this.performanceGridData = newPivotCollection;
      }
   }

   onResize($event) {
     this.resizePivotUI();
   }

   private resizePivotUI() {
     if (typeof window['ResizePivotUI'] !== 'function') { return; }
     if ($("#pivotviewer .pv-mainpanel").length === 0) { return; }
     window['ResizePivotUI']();
   }

    /*display dashboard in modal -> zoom in/out*/
    dashboardZoomModal() {
        if($("#pivotviewer").hasClass("modal")){
            $("body").removeClass('modal-open');
            $("#dashboardModal").removeAttr("data-toggle");
            $("#dashboardModal").removeAttr("data-target");
            $("#dashboardModal").attr("data-dismiss", "#modal");
            $("#pivotviewer").removeClass('modal animated fadeIn');
            $(".pv-mainpanel").removeClass('modal-content');
            $(".pv-mainpanel").css("height", "100vh");
            $("div").removeClass("modal-backdrop in");
            this._appStateProvider.updateLayout();
            this.resizePivotUI();
        }else{
            $("#dashboardModal").attr("data-toggle", "modal");
            $("#dashboardModal").attr("data-target", "#pivotviewer");
            $("#pivotviewer").addClass('modal animated fadeIn');
            $(".pv-mainpanel").addClass('modal-content');
            $(".pv-mainpanel").css("height", "100vh"); 
            this._appStateProvider.updateLayout();
            this.resizePivotUI();
        } 
    }

    loadSelectedPortfolio(id) {
        let settingsRef = window['settingsComponentRef'].component;
        let multiSelectBox: kendo.ui.MultiSelect = $("#portfoliosMultiSelect").data("kendoMultiSelect");
        //if user try to load portfolio while is on modal state!
        $("div").removeClass("modal-backdrop in");
        this._router.navigate(['/home']);
        /*if partner is already selected, filter and data source needs to be reset in order to properly select
          and display selected portfolio*/
        if ($("#partner").data("kendoDropDownList").value() !== "0") {
            $("#partner").data("kendoDropDownList").value("0");
            multiSelectBox.dataSource.filter([]);
            multiSelectBox.setDataSource(multiSelectBox.dataSource);
            multiSelectBox.value([+id]);
            MultiSelectCustomModule.onMultiselectPortfoliosChange(undefined);
        } else {
            multiSelectBox.value([+id]);
            MultiSelectCustomModule.onMultiselectPortfoliosChange(undefined);
        }
        window['settingsComponentRef'].zone.run(() => {settingsRef.initDataFetching();});
        $("#filter").collapse('hide');
    }
  

  getLoginAndSessionID(performanceID){
    let sessionID: string = localStorage.getItem('sessionid');
    if (sessionID) {
        $('#pivotviewer').text('');
        loadPivotCollectionFactory(sessionID, performanceID);
    }
  }

ngAfterContentInit() {
   if(this.performanceID===undefined){
       this.performanceID = 0;
   } 
    this._insaService.getPerformancePivotList();
    this.getLoginAndSessionID(this.performanceID);
    //AttachEventHandlers();
    //http://www.insa-online.com/InsaSLWebSite/Services/InsaSLPortalApp-Web-AuthenticationService.svc/Json/
}

  ngOnDestroy(){
    this.pivotCollectionSubscription.unsubscribe();
  }

}


// WEBPACK FOOTER //
// ./app/insa-pivot/pivot.component.ts